<app-navbar>
    <h2>{{'GUIDANCE.TITLE' | translate}}</h2>
</app-navbar>

<!-- bloc 0 -->
<section class="ptb-70 white-background">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <img src="assets/img/counseling-guidance/block1.jpg" alt="">
            </div>
            <div class="col-md-6">
                <h2 class="custom-section-title">{{'GUIDANCE.INTRODUCTION_TITLE' | translate}}</h2>
                <p>{{'GUIDANCE.INTRODUCTION_TEXT' | translate}}</p>   
                <a class="green-button" routerLink="/blog">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
            </div>
            
        </div>
    </div>
</section>

<!-- bloc1 -->
        <section class="ptb-70 white-background">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <h2 class="custom-section-title">{{'GUIDANCE.DISC_JR_TITLE' | translate}}</h2>
                        <p [innerHTML]="'GUIDANCE.DISC_JR_HTML' | translate"></p>   
                            <ol [innerHTML]="'GUIDANCE.DISC_JR_LIST_HTML' | translate"></ol>
                        <h2 class="custom-section-title">{{'GUIDANCE.DISC_ADULT_TITLE' | translate}}</h2>
                        <p [innerHTML]="'GUIDANCE.DISC_ADULT_HTML' | translate"></p>
                        <!-- <a class="green-button" routerLink="/blog">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a> -->
                    </div>
                    
                    <div class="col-md-6">
                        <img src="assets/img/counseling-guidance/model.png" alt="">
                    </div>
                </div>
            </div>
        </section>

        <!-- bloc2 -->

        <section class="ptb-70 grey-background">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <img src="/assets/img/home-1/about-agribusiness.png" alt="">
                    </div>
                    <div class="col-md-6">
                        <h2 class="custom-section-title">{{'GUIDANCE.PERSONALITY_TITLE' | translate}}</h2>
                        <p [innerHTML]="'GUIDANCE.PERSONALITY_HTML' | translate"></p>     
                        <a class="green-button" routerLink="/evaluare-personalitate">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                    </div>
                </div>                
            </div>            
        </section>

        <!-- bloc3 -->
        <section class="ptb-70 white-background">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <h2 class="custom-section-title">{{'GUIDANCE.CV_TITLE' | translate}}</h2>
                            <p>{{'GUIDANCE.CV_TEXT' | translate}}</p>   
                            <a class="green-button" routerLink="/blog">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                    </div>
                    <div class="col-md-6">
                        <img src="../../../assets/img/counseling-guidance/cv.jpeg" alt="">
                    </div>
                </div>
            </div>
        </section>

        <!-- bloc4 -->
        <section class="ptb-70 grey-background">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <img src="../../../assets/img/counseling-guidance/interview.jpeg" alt="">
                    </div>
                    <div class="col-md-6">
                        <h2 class="custom-section-title">{{'GUIDANCE.INTERVIEW_TITLE' | translate}}</h2>
                        <p>{{'GUIDANCE.INTERVIEW_TEXT' | translate}}</p>   
                        <a class="green-button" routerLink="/blog">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                    </div>
                </div>                
            </div>            
        </section>

        <!-- bloc5 -->
        <section class="ptb-70 white-background">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <h2 class="custom-section-title">{{'GUIDANCE.KNOWLEDGE_TITLE' | translate}}</h2>
                            <p [innerHTML]="'GUIDANCE.KNOWLEDGE_HTML' | translate"></p>   
                            <a class="green-button" href="https://testeabj.nexloc.com/" target="_blank">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                    </div>
                    <div class="col-md-6">
                        <img src="/assets/img/home-1/info-area-1.png" alt="">
                    </div>
                </div>
            </div>
        </section>

        <!-- bloc6 -->
        <section class="ptb-70 grey-background">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <img src="/assets/img/home-1/info-area-3.png" alt="">
                    </div>
                    <div class="col-md-6" >
                        <h2 class="custom-section-title">{{'GUIDANCE.IMPROVE_TITLE' | translate}}</h2>
                        <p>{{'GUIDANCE.IMPROVE_TEXT' | translate}}</p>   
                        <a class="green-button" href=" https://testeabj.nexloc.com/" target="_blank">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                    </div>
                </div>                
            </div>            
        </section>

        <!-- bloc7 -->
        <section class="ptb-70 white-background">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <h2 class="custom-section-title">{{'GUIDANCE.SALARY_TITLE' | translate}}</h2>
                        <p>{{'GUIDANCE.SALARY_TEXT' | translate}}</p>   
                        <a class="green-button" href="http://www.calculator-salarii.ro" target="_blank">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                    </div>
                    <div class="col-md-6">
                        <img src="/assets/img/home-1/info-area-2.png" alt="">
                    </div>
                </div>          
            </div>            
        </section>

<!-- bloc8 -->
        <section class="ptb-70 grey-background">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <img src="assets/img/counseling-guidance/bloc8.jpg" alt="">
                    </div>
                    <div class="col-md-6">
                        <h2 class="custom-section-title">{{'GUIDANCE.STUDY_TITLE' | translate}}</h2>
                        <p [innerHTML]="'GUIDANCE.STUDY_HTML' | translate"></p>   
                        <a class="green-button" routerLink="/contact">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                    </div>
                </div>                
            </div>            
        </section>
       
<app-footer></app-footer>
